/**
 * AI Assistant Page
 * Standalone page for AI assistant chat
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import AIAssistantTab from './AIAssistantTab';

const AIAssistantPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          AI Assistant
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Chat with your AI assistant for insights and help
        </Typography>
      </Box>
      <AIAssistantTab />
    </Container>
  );
};

export default AIAssistantPage;
